import React from 'react';
import Banner from '../components/home/banner';
import Experience from '../components/home/experience';
import Services from '../components/home/services';
import Video from '../components/home/video';
import About from '../components/home/about'; 
import Contact from '../components/home/contact'; 
// import Checkmobile from '../components/checkmobile';

function homepage() {
  return (
    <div>
        <Banner/>
        {/* <Checkmobile/> */}
        <Experience/>
        <Services/>
        <Video/>
        <About/>
        
        <Contact/>
    </div>
  )
}

export default homepage